// extracted by mini-css-extract-plugin
export default {"banner":"total-banner-module__banner___O8BVw","text":"total-banner-module__text___MQnf1"};